import React from "react";
import { createGlobalStyle } from "styled-components";
import CountDown from "../ClubKachar/CountDown";
import { ReacordLottary } from "./RecordLottary";
import { apiCall_domainV2 } from "../../api";
import axios from "axios";
import { Navigation, Pagination } from "swiper/modules";
import Spinner from "../../Spinner/Spinner";

import { Swiper, SwiperSlide } from "swiper/react";
import Header from "../../header";

export class LottaryPage extends React.Component {
  state = {
    luckModal: false,
    data: null,
    loading: true,
  };
  increaceLuckHandler = () => {
    this.setState({ luckModal: !this.state.luckModal });
  };

  componentDidMount() {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    let { id } = this.props.match.params;
    axios
      .get(`${apiCall_domainV2}/customer/market/lottery/details/${id}`, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ data: res.data, loading: false });
      });
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #262626 !important;
    }`;
    return (
      <div className="lottaryPageContainer">
        <GlobalStyles />
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            {!this.state.luckModal && this.state.data && (
              <>
                <div className="lottaryPageHeader">
                  <Header
                    showSearchBar={true}
                    title="باشگاه مشتریان"
                    isDarkTheme={true}
                    changeDetail={true}
                  />

                  <div className="countDownDiv">
                    <div className="lotteryDetails">
                      <h2>{this.state.data?.lottery?.title}</h2>
                      <span>روز شمار برگزاری قرعه کشی</span>
                    </div>
                    <CountDown
                      expire_time={this.state.data?.lottery.expire_time}
                    />
                  </div>
                </div>
                <div className="lottaryPageBody">
                  <div className="enteringLottery">
                    <div>
                      <h2>{this.state.data?.lottery.title}</h2>
                      <span>{this.state.data?.lottery.description}</span>
                    </div>
                    <span>
                      <img src="/public/assets/coin.svg" alt="coin" />
                      هر {this.state.data?.lottery.required_points} امتیاز یک
                      شانس شرکت در قرعه کشی
                    </span>

                    <div>
                      <div>
                        <span>کل امتیازات شما</span>
                        <span>
                          <span>
                            {this.state.data?.lottery.customer_details.points}
                          </span>
                          امتیاز
                        </span>
                      </div>
                      <div>
                        <span>تعداد شانس های شرکت در قرعه کشی</span>

                        <span>
                          <span>
                            {
                              this.state.data?.lottery.customer_details
                                .chances_count
                            }
                          </span>
                          شانس
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="moreChancwBtn"
                    onClick={this.increaceLuckHandler}
                  >
                    دریافت شانس بیشتر
                  </div>
                  <div className="lottaryProduct">
                    <Swiper
                      spaceBetween={5}
                      slidesPerView={3}
                      breakpoints={{
                        260: {
                          slidesPerView: 1.2,
                        },
                        400: {
                          slidesPerView: 2,
                        },
                      }}
                      navigation={true}
                      modules={[Navigation, Pagination]}
                    >
                      {this.state.data.awards.map((item) => (
                        <SwiperSlide>
                          <div className="SwiperIntro">
                            <img src={item.image} alt="SwiperIntro"></img>
                            <div className="Text">
                              <h2 className="SwiperTitle">{item.title}</h2>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {this.state.luckModal && (
          <ReacordLottary
            increaceLuckHandler={this.increaceLuckHandler}
            data={this.state.data.lottery}
            maximum_chance={this.state.data.allowed_join_lottery_count}
            current_points={this.state.data.current_points}
          />
        )}
      </div>
    );
  }
}
